import styles from '../../styles/Button.module.css';

const Button = ({children, onClick, buttonStyle, ...props}) => {
    return (
      <button
        onClick={onClick} {...props}
        /*className={`bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded ${className}`}*/
        className ={styles[buttonStyle || 'btn-main']}        
      >
        {children}
      </button>
    );
  };
  
  export default Button;
  